module.exports = __webpack_public_path__ + "img/03.c79dd7d1.png";